import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { readStoredAppearancePreference } from "@/config/themes";
import { APPEARANCE_STORAGE_KEY } from "@/constants";
import type { AppearancePreference } from "@/config/themes/types";
import type { RootState } from "@/app/store";

export type AppearanceState = {
  preference: AppearancePreference;
};

export const appearanceInitialState: AppearanceState = {
  preference: readStoredAppearancePreference(),
};

const appearanceSlice = createSlice({
  name: "appearance",
  initialState: appearanceInitialState,
  reducers: {
    setAppearancePreference(state, action: PayloadAction<AppearancePreference>) {
      state.preference = action.payload;
      try {
        localStorage.setItem(APPEARANCE_STORAGE_KEY, action.payload);
      } catch {
        // Ignore write failures in restricted contexts.
      }
    },
  },
});

export const { setAppearancePreference } = appearanceSlice.actions;
export const appearanceReducer = appearanceSlice.reducer;

export function selectAppearancePreference(state: RootState): AppearancePreference {
  return state.appearance.preference;
}
